/**
 * Provider-agnostic auth actions interface.
 *
 * The Auth0 sync provider registers its implementation at mount time.
 * Components use the React context (AuthActionsContext);
 * non-React code (baseQuery) uses the module-level registry below.
 */
export interface LoginOptions {
  organization?: string;
  tenantCode?: string;
  invitation?: string;
  returnTo?: string;
}

export interface AuthActions {
  login(options?: LoginOptions): Promise<void>;
  logout(): Promise<void>;
  getAccessToken(): Promise<string | null>;
}

// ---------------------------------------------------------------------------
// Module-level registry (for non-React consumers like baseQuery)
// ---------------------------------------------------------------------------

let currentActions: AuthActions | null = null;

export function registerAuthActions(actions: AuthActions): void {
  currentActions = actions;
}

export function unregisterAuthActions(): void {
  currentActions = null;
}

export function getAuthActions(): AuthActions | null {
  return currentActions;
}
